import { handleActions } from "redux-actions";
import { ERROR_ACTIONS } from "./actions";

const initialState = {
  error: {},
  showError: false,
} as ErrorState;

export default handleActions(
  {
    [ERROR_ACTIONS.SET_ERROR]: (state: ErrorState, { payload }) => {
      return {
        ...state,
        error: payload,
        showError: true,
      };
    },
    [ERROR_ACTIONS.CLEAR_ERROR]: (state: ErrorState) => {
      return {
        ...state,
        error: {},
        showError: false,
      };
    },
    [ERROR_ACTIONS.SET_SHOW_STATUS]: (
      state: ErrorState,
      { payload }: { payload: boolean }
    ) => {
      return {
        ...state,
        showError: payload,
      };
    },
  },
  initialState
);

export interface ErrorState {
  error: any;
  showError: boolean;
}
